/* VVSex Candy theme JS */
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  window.vvsToast = function (msg) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('on'); }, 2600);
  };

  function initGate() {
    var gate = $('[data-age-gate]');
    if (!gate) return;
    try {
      if (!localStorage.getItem('vvsAge18')) gate.classList.add('show');
    } catch (e) { gate.classList.add('show'); }
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 }) : null;

  function observeRv() {
    $$('.rv:not(.in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('in');
    });
  }

  function openCart() {
    var d = $('#cart'), s = $('#scrim');
    if (d) d.classList.add('on');
    if (s) s.classList.add('on');
  }
  function closeCart() {
    var d = $('#cart'), s = $('#scrim');
    if (d) d.classList.remove('on');
    if (s) s.classList.remove('on');
  }
  window.vvsOpenCart = openCart;

  function refreshCart(open) {
    return fetch(window.location.pathname + '?sections=vvs-cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['vvs-cart-drawer'];
        var wrap = $('#shopify-section-vvs-cart-drawer');
        if (wrap && html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          wrap.replaceWith(tmp.firstElementChild);
        }
        var count = $('[data-cart-item-count]');
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = count ? count.getAttribute('data-cart-item-count') : '0';
        });
        if (open) openCart();
      });
  }

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-gate-yes]'))) {
      try { localStorage.setItem('vvsAge18', '1'); } catch (err) {}
      var g = $('[data-age-gate]');
      if (g) g.classList.remove('show');
      return;
    }
    if ((t = e.target.closest('[data-gate-no]'))) {
      window.location.href = t.getAttribute('data-gate-no') || 'https://www.google.com';
      return;
    }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('#scrim')) { closeCart(); return; }

    if ((t = e.target.closest('[data-line-remove]'))) {
      e.preventDefault();
      t.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(t.getAttribute('data-line-remove'), 10), quantity: 0 })
      }).then(function () { refreshCart(true); });
      return;
    }

    if ((t = e.target.closest('[data-quick-add]'))) {
      e.preventDefault();
      t.classList.add('busy');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(t.getAttribute('data-quick-add'), 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.vvsToast('Added to cart ✦');
        return refreshCart(true);
      }).catch(function () {
        window.vvsToast('Could not add — try again');
      }).finally(function () { t.classList.remove('busy'); });
      return;
    }

    if ((t = e.target.closest('[data-qty]'))) {
      var input = $('input', t.closest('.qty'));
      if (input) {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(t.getAttribute('data-qty'), 10));
      }
      return;
    }

    if ((t = e.target.closest('.acc-head'))) {
      var item = t.parentNode, body = $('.acc-body', item);
      if (item.classList.contains('open')) {
        item.classList.remove('open'); body.style.maxHeight = 0;
      } else {
        item.classList.add('open'); body.style.maxHeight = body.scrollHeight + 'px';
      }
      return;
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-atc-form]');
    if (!f) return;
    e.preventDefault();
    var btn = $('[type="submit"]', f);
    if (btn) btn.classList.add('busy');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.vvsToast('Added to cart ✦');
        return refreshCart(true);
      })
      .catch(function () { window.vvsToast('Could not add — try again'); })
      .finally(function () { if (btn) btn.classList.remove('busy'); });
  });

  window.addEventListener('scroll', function () {
    var n = $('#nav');
    if (n) n.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });

  function initAcc() {
    $$('.acc-item.open .acc-body').forEach(function (b) {
      b.style.maxHeight = b.scrollHeight + 'px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initGate(); observeRv(); initAcc(); });
  } else {
    initGate(); observeRv(); initAcc();
  }
})();

/* v2: mobile menu */
(function () {
  'use strict';
  function tg(s) { return document.querySelector(s); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      e.preventDefault();
      if (tg('#mmenu')) tg('#mmenu').classList.add('on');
      if (tg('#mscrim')) tg('#mscrim').classList.add('on');
      return;
    }
    if (e.target.closest('[data-menu-close]') || e.target.closest('#mmenu a')) {
      if (tg('#mmenu')) tg('#mmenu').classList.remove('on');
      if (tg('#mscrim')) tg('#mscrim').classList.remove('on');
    }
  });
})();
